import { replenishmentSCListUrl,
    replenishmentStockListUrl,
    fOneBatchAddUrl,
    fOneAddUrl,
    fOneCartCountUrl,
    fOneCartDeleteUrl,
    fOneCartQuantityUrl,
    fOneCartQueryUrl,
    getF1CartLatestDnsaUrl,
    submitF1OrderUrl,
    fOneOrderQueryUrl,
    viewFoneOrderUrl,
    f1CancelOrderUrl,
    f1UpdateOrderUrl,
    invalidSkuListUrl,
    inventoryDetailsUrl,
    addSelectedLotCacheUrl,
    replenishmentValidSkuUrl,
    replenishmentAddCartUrl,
    sysDictUrl } from 'Utils/urlUtil'
import { callApi, get, post } from 'Utils/apiUtil'
import util from 'Utils/commonUtil'

export const REPLENISHMENT_SC_LIST = 'REPLENISHMENT_SC_LIST';
export const REPLENISHMENT_STOCK_LIST = 'REPLENISHMENT_STOCK_LIST';
export const FONE_CART_COUNT = 'FONE_CART_COUNT';
export const ADD_FONE_PRODUCT = 'ADD_FONE_PRODUCT';
export const BATCH_ADD_FONE_PRODUCT = 'BATCH_ADD_FONE_PRODUCT';
export const F1_CART_LIST = 'F1_CART_LIST';
export const F1_DELETE_LIST = 'F1_DELETE_LIST';
export const SUBMIT_ORDER_LIST = 'SUBMIT_ORDER_LIST';
export const F1_ORDER_TAB_ACTIVE = 'F1_ORDER_TAB_ACTIVE';
export const F1_ORDER_QUANTITY = 'F1_ORDER_QUANTITY';
export const F1_ORDER_QUERY = 'F1_ORDER_QUERY';
export const F1ORDER_SEARCH_FIELD = 'F1ORDER_SEARCH_FIELD';
export const ORDER_MORE_SUCCESS = 'ORDER_MORE_SUCCESS';
export const ORDER_MORE_INITIAL = 'ORDER_MORE_INITIAL';
export const ORDER_MORE_FAILURE = 'ORDER_MORE_FAILURE';
export const FONE_ORDER_DETAILS = 'FONE_ORDER_DETAILS';
export const CANCEL_F1_ORDER = 'CANCEL_F1_ORDER';
export const UPDATE_F1_ORDER = 'UPDATE_F1_ORDER';
export const STOCK_MORE_SUCCESS = 'STOCK_MORE_SUCCESS';
export const STOCK_MORE_INITIAL = 'STOCK_MORE_INITIAL';
export const STOCK_MORE_FAILURE = 'STOCK_MORE_FAILURE';
export const INVALID_SKU = 'INVALID_SKU';
export const INVENTORY_DETAILS = 'INVENTORY_DETAILS';
export const F1ORDER_DETAIL = 'F1ORDER_DETAIL';
export const SYS_DICT = 'SYS_DICT';
export const F1_CART_SELECTED_LOT_LIST = 'F1_CART_SELECTED_LOT_LIST';
export const VALID_SKU = 'VALID_SKU';
export const PUSH_ADD_CART = 'PUSH_ADD_CART';

const abyss = (data, length) => {
let showAbyss = false
if (util.isArray(data) && data.length < length) {
   showAbyss = true
}
return showAbyss
}

// Get SC list
export function getSCList(params, func) {
const request = null
const options = { data: params}
const success = (response) => ({ type: REPLENISHMENT_SC_LIST, payload: response })
const failure = null

return callApi(replenishmentSCListUrl, options, request, success, failure, func)
}

// Get SC Stock Details
export function getSCInventroyDetails(params, func) {
const request = null
const options = { data: params}
const success = (response) => ({ type: REPLENISHMENT_STOCK_LIST, payload: { replenishmentStockList: response, stockListLoaded: true } })
const failure = null

return callApi(replenishmentStockListUrl, options, request, success, failure, func)
}

// Get More Stocks
export function getMoreStock(params) {

return (dispatch, getState) => {

   const replenishment = getState().replenishment

   const options = {
       data: {
           'type': params.type,
           'pageNum': params.pageNum,
           'pageSize': params.pageSize,
           'supplyCenterId':  params.supplyCenterId,
           'queryKey': params.queryKey
       }
   }
   const request = () => ({ type: STOCK_MORE_INITIAL, payload: { stockListLoaded: false, stockLoadingMore: true, stockAbyss: false } })
   const failure = () => ({ type: STOCK_MORE_FAILURE, payload: { stockListLoaded: true, stockLoadingMore: false, stockAbyss: true } })
   const success = (response) => {

       const apiReponseData = response.data;
       const list = util.isArray(response.data) ? replenishment.replenishmentStockList.data.concat(response.data) : [];
       response.data = list;

       return { type: STOCK_MORE_SUCCESS, payload: { replenishmentStockList: response, stockListLoaded: true, stockLoadingMore: false, stockAbyss: abyss(apiReponseData, replenishment.replenishmentStockList.pageSize) } }
   }

   return dispatch(callApi(replenishmentStockListUrl, options, request, success, failure))
}
}

// Get F1 Cart Count
export const getF1CartCount = (id) => {
return dispatch => dispatch(get(fOneCartCountUrl, { supplyCenterId: id })).then(res => {
   dispatch({ type: FONE_CART_COUNT, payload: res });
});
};

// Add Product To F1 Cart
export function AddF1Product(params) {
const request = null
const options = { data: params}
const success = (response) => ({ type: ADD_FONE_PRODUCT, payload: response })
const failure = null

return callApi(fOneAddUrl, options, request, success, failure)
}

// Batch Add Product To F1 Cart
export function BatchAddF1Product(params) {
const request = null
const options = { data: params}
const success = (response) => ({ type: BATCH_ADD_FONE_PRODUCT, payload: response })
const failure = null

return callApi(fOneBatchAddUrl, options, request, success, failure)
}

// Query F1 Shopping Cart
export function QueryF1Cart(params, func) {
const request = null
const options = { data: params}
const success = (response) => ({ type: F1_CART_LIST, payload: response })
const failure = null

return callApi(fOneCartQueryUrl, options, request, success, failure, func)
}

// Query F1 Shopping Cart
export function getF1CartSelectedLotList(params, func) {
const request = null
const options = { data: params}
const success = (response) => ({ type: F1_CART_SELECTED_LOT_LIST, payload: response })
const failure = null

return callApi(getF1CartLatestDnsaUrl, options, request, success, failure, func)
}

export const addSelectedLotCache = data => post(addSelectedLotCacheUrl, data);

// Delete F1 Shopping Cart
export function DeleteF1Cart(params, func) {
const request = null
const options = { data: params}
const success = (response) => ({ type: F1_DELETE_LIST, payload: response })
const failure = null

return callApi(fOneCartDeleteUrl, options, request, success, failure, func)
}

// Submit F1 Shopping Cart Quantity
export function sumbitF1Quantity(params) {
const request = null
const options = { data: params}
const success = (response) => ({ type: F1_ORDER_QUANTITY, payload: response })
const failure = null

return callApi(fOneCartQuantityUrl, options, request, success, failure)
}

// Submit F1 Order
export function submitF1Order(params, func) {
const request = null
const options = { data: params}
const success = (response) => ({ type: SUBMIT_ORDER_LIST, payload: response })
const failure = null

return callApi(submitF1OrderUrl, options, request, success, failure, func)
}

// Query F1 Order
export function fOneOrderQuery(params, func) {
const request = null
const options = { data: params}
const success = (response) => ({ type: F1_ORDER_QUERY, payload: { f1OrderList: response, replenishmentListLoaded: true } })
const failure = null

return callApi(fOneOrderQueryUrl, options, request, success, failure, func)
}

// Get More Orders
export function getMoreOrders(params) {

return (dispatch, getState) => {

   const replenishment = getState().replenishment

   const options = {
       data: {
           'tabFlag': params.tabFlag,
           'pageNum': params.pageNum,
           'pageSize': params.pageSize,
           'queryKey':  params.queryKey
       }
   }
   const request = () => ({ type: ORDER_MORE_INITIAL, payload: { replenishmentListLoaded: false, replenishmentLoadingMore: true, replenishmentAbyss: false } })
   const failure = () => ({ type: ORDER_MORE_FAILURE, payload: { replenishmentListLoaded: true, replenishmentLoadingMore: false, replenishmentAbyss: true } })
   const success = (response) => {

       const apiReponseData = response.data;
       const list = util.isArray(response.data) ? replenishment.f1OrderList.data.concat(response.data) : [];
       response.data = list;

       return { type: ORDER_MORE_SUCCESS, payload: { f1OrderList: response, replenishmentListLoaded: true, replenishmentLoadingMore: false, replenishmentAbyss: abyss(apiReponseData, replenishment.f1OrderList.pageSize) } }
   }

   return dispatch(callApi(fOneOrderQueryUrl, options, request, success, failure))
}
}

// Update F1 Order Tab Active
export const updateAdminF1OrderTabActive = params => ({ type: F1_ORDER_TAB_ACTIVE, payload: params });

// Update F1 Order Search Fields
export const updateAdminF1OrderSearchFields = params => ({ type: F1ORDER_SEARCH_FIELD, payload: params });

// Update F1 Order Detail
export const updateAdminF1OrderDetail = params => ({ type: F1ORDER_DETAIL, payload: params });

// Get F1 Order Detail
export const viewF1Order = (id, func) => {
    return dispatch => dispatch(get(viewFoneOrderUrl, { id })).then(res => {
    dispatch({ type: FONE_ORDER_DETAILS, payload: res });
    func && func(res);
    })
}

// Submit F1 Order
export function cancelF1Order(params, func) {
const request = null
const options = { data: params}
const success = (response) => ({ type: CANCEL_F1_ORDER, payload: response })
const failure = null

return callApi(f1CancelOrderUrl, options, request, success, failure, func)
}

//query invalid sku
export function queryInvalidSku(params, func) {
const request = null
const options = { data: params}
const success = (response) => ({ type: INVALID_SKU, payload: response })
const failure = null

return callApi(invalidSkuListUrl, options, request, success, failure, func)
}

// Submit F1 Order
export function updateF1Order(params, func) {
const request = null
const options = { data: params}
const success = (response) => ({ type: UPDATE_F1_ORDER, payload: response })
const failure = null

return callApi(f1UpdateOrderUrl, options, request, success, failure, func)
}

// Get Company Inventory Details
export function getInventoryDetails(sku, func) {
    return dispatch => dispatch(get(inventoryDetailsUrl, { sku })).then(res => {
        dispatch({ type: INVENTORY_DETAILS, payload: res });
        func && func(res);
    });
}

export function getSysDict(dictType) {
    return dispatch => dispatch(get(sysDictUrl, { dictType })).then(res => {
        dispatch({ type: SYS_DICT, payload: res });
    });
}

// check sku
export const checkSku = (scId,sku) => {
    return dispatch => dispatch(get(replenishmentValidSkuUrl, { scId,sku })).then(res => {
        dispatch({ type: VALID_SKU, payload: res });
        return res
    });
};

//add cart
export function pushAddCart(params, func) {
    const request = null
    const options = { data: params}
    const success = (response) => ({ type: PUSH_ADD_CART, payload: response })
    const failure = null
    
    return callApi(replenishmentAddCartUrl, options, request, success, failure, func)
}

